import { PropsWithChildren, useEffect } from 'react'
import { useRouter } from 'next/router'

import ButtonSticky from '@/components/base/button-sticky'
import Controller from '@/components/layout/controller'
import Footer from '@/components/layout/footer'
import { LenisProvider } from '@/contexts/lenis'
import { useLocaleStore } from '@/store/locale'
import { useRouterStore } from '@/store/router'

import { WPPageData } from '@/types'

export type LayoutProps = PropsWithChildren<{ pageProps: WPPageData }>

const Layout = ({
  pageProps: { wpml_translations },
  children
}: LayoutProps) => {
  const router = useRouter()
  const setCurrentRoute = useRouterStore((state) => state.setCurrentRoute)
  const setCurrentLocale = useLocaleStore((state) => state.setCurrentLocale)
  const setCurrentTranslations = useLocaleStore(
    (store) => store.setCurrentTranslations
  )

  useEffect(() => {
    setCurrentRoute(router.asPath)
    setCurrentLocale(router.locale)
    setCurrentTranslations(wpml_translations || [])
  }, [
    router,
    wpml_translations,
    setCurrentRoute,
    setCurrentLocale,
    setCurrentTranslations
  ])

  return (
    <LenisProvider>
      <Controller />
      <div className="static">
        {children}
        <ButtonSticky />
      </div>
      <Footer />
    </LenisProvider>
  )
}

export default Layout
